import { Navigate, useParams, useSearchParams } from 'react-router-dom'

export function LegacyCommunityPostRedirect() {
  const { postId } = useParams<{ postId: string }>()
  const [searchParams] = useSearchParams()
  const targetPostId = postId?.trim() ?? ''

  if (!targetPostId.length) {
    return <Navigate to="/board" replace />
  }

  const redirectSearchParams = new URLSearchParams(searchParams)
  redirectSearchParams.delete('fromBoard')
  redirectSearchParams.set('post', targetPostId)

  const queryString = redirectSearchParams.toString()
  const redirectPath = queryString.length > 0 ? `/board?${queryString}` : '/board'

  return <Navigate to={redirectPath} replace />
}
